import api from "../../../config/gatewayConfig";
import { httpClient } from "../../httpClient";
import {
  validateVendorTopProductsClickResponse,
  validateVendorTrafficResponse,
  validateVendorTopCategoriesByClickResponse,
} from "../../schemas/vendorStatsSchemas";

export const apiVendorStatsProvider = {
  getTopProductsByClick: async (body) => {
    const response = await httpClient.post(api.vendorTopProductsByClick, body, {
      headers: { "Content-Type": "application/json" },
    });
    return validateVendorTopProductsClickResponse(response.data);
  },

  getVendorTraffic: async (body) => {
    const response = await httpClient.post(api.vendorTraffic, body, {
      headers: { "Content-Type": "application/json" },
    });
    return validateVendorTrafficResponse(response.data);
  },

  getTopCategoriesByClick: async (body) => {
    const response = await httpClient.post(api.vendorTopCategoriesByClick, body, {
      headers: { "Content-Type": "application/json" },
    });
    return validateVendorTopCategoriesByClickResponse(response.data);
  },
};
